
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"applyPromoCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"commonInput"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ApplyPromoCodeCommonInput"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"packageInput"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ApplyPromoCodePackageInput"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shoppingInput"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ApplyPromoCodeShoppingInput"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applyPromoCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"commonInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"commonInput"}}},{"kind":"Argument","name":{"kind":"Name","value":"packageInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"packageInput"}}},{"kind":"Argument","name":{"kind":"Name","value":"shoppingInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shoppingInput"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"net_price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"package_price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"additionalPrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isBoubyanOnly"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deema_package_price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deema_net_price"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":423}};
    doc.loc.source = {"body":"mutation applyPromoCode($commonInput: ApplyPromoCodeCommonInput, $packageInput: ApplyPromoCodePackageInput, $shoppingInput: ApplyPromoCodeShoppingInput, $customerId: ID) {\n  applyPromoCode(commonInput: $commonInput, packageInput: $packageInput, shoppingInput: $shoppingInput, customerId: $customerId) {\n    net_price\n    package_price\n    additionalPrice\n    isBoubyanOnly\n    deema_package_price\n    deema_net_price\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["applyPromoCode"] = oneQuery(doc, "applyPromoCode");
        
